
export const nextInformedDeliveryApis = ({fetcher}) => ({
    getRideAlong: async () => await fetcher.getJson(
        `/next-api/informed_delivery/get_ride_along_images`
    ),
});

